import request from '@/utils/request';

export function optimizationAPI() {
  return {
    // 列表
    optimizationList: params => {
      return request({
        url: '/admin/auth/optimizer/list',
        method: 'get',
        params,
      });
    },
    // 小程序名称列表
    applicationList: params => {
      return request({
        url: '/admin/mapps/list',
        method: 'get',
        params,
      });
    },
    //新增
    newlyAdded: data => {
      return request({
        url: '/admin/auth/optimizer/edit',
        method: 'post',
        data
      });
    },
      // 详情数据
      detailsList: params => {
        return request({
          url: `/admin/auth/optimizer/info?id=${params}`,
          method: 'get',
        });
      },
  };
}
